class MathUtil {
  /**
   * 角度をラジアンに変更
   */
  public static degreeToRadian(degree: number): number {
    return degree * (Math.PI / 180)
  }

  /**
   * 範囲からランダムな数値を返します
   */
  public static getRandomArbitrary(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min) + min)
  }
}

export default MathUtil
